import { createSlice } from "@reduxjs/toolkit";
import { storeBuilder } from "./thunks";

export const initialState = {
    stores : [],
    storesFilter : [],
    error : null,
    isLoading : false
}


export const storeSlice = createSlice({
    name : 'store',
    initialState,
    reducers : {
        setStoresFilter(state, action){
            state.storesFilter = action.payload
        }
    },
    extraReducers : storeBuilder
})

export const {setStoresFilter} = storeSlice.actions
export default storeSlice.reducer